import { createRouter, createWebHashHistory } from 'vue-router'

import AboutView from '../views/AboutView.vue'
import CombatLogsView from '../views/CombatLogsView.vue'
import CompareView from '../views/CompareView.vue'
import FavoritesView from '../views/FavoritesView.vue'
import GearInsightsView from '../views/GearInsightsView.vue'
import NewsArticleView from '../views/NewsArticleView.vue'
import MythicPlusView from '../views/MythicPlusView.vue'
import NewsView from '../views/NewsView.vue'
import NotFoundView from '../views/NotFoundView.vue'
import RaidingView from '../views/RaidingView.vue'
import SettingsView from '../views/SettingsView.vue'

const routes = [
  { path: '/', redirect: '/mythic-plus' },
  { path: '/raiding', name: 'raiding', component: RaidingView, meta: { title: 'Raiding' } },
  { path: '/mythic-plus', name: 'mythic-plus', component: MythicPlusView, meta: { title: 'Mythic Plus' } },
  { path: '/news', name: 'news', component: NewsView, meta: { title: 'News' } },
  { path: '/news/article', name: 'news-article', component: NewsArticleView, meta: { title: 'News article' } },
  { path: '/gear-insights', name: 'gear-insights', component: GearInsightsView, meta: { title: 'Build insights' } },
  { path: '/favorites', name: 'favorites', component: FavoritesView, meta: { title: 'Favorite characters' } },
  { path: '/combat-logs', name: 'combat-logs', component: CombatLogsView, meta: { title: 'Combat Logs' } },
  { path: '/compare', name: 'compare', component: CompareView, meta: { title: 'Character compare' } },
  { path: '/about', name: 'about', component: AboutView, meta: { title: 'About application', landing: true } },
  { path: '/settings', name: 'settings', component: SettingsView, meta: { title: 'Settings' } },
  { path: '/:pathMatch(.*)*', name: 'notfound', component: NotFoundView, meta: { title: 'Page not found' } },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior() {
    const wrapper = document.querySelector('.app-global-wrapper')
    if (wrapper) wrapper.scroll({ top: 0 })
    return { top: 0 }
  },
})

router.afterEach((to) => {
  document.title = `${to.meta.title || 'Raider.io Dashboard'} | Raider.io Dashboard`
})

export default router
